













import { Component, Prop, Vue } from 'vue-property-decorator';
import { CardLinkTitle } from './types';

@Component
export default class MenuCard extends Vue {
  @Prop({ type: String, default: '' })
  readonly type!: string;

  get modificator() {
    const { type } = this;
    return !type ? '' : `menucard_${type}`;
  }

  get goToPath() {
    const { type } = this;
    if (type) return { name: `profile-${type}` };
    return { name: 'profile-cabinet' };
  }

  get title() {
    const { type } = this;
    switch (type) {
      case 'calendar':
        return CardLinkTitle.CALENDAR;
      case 'webinars':
        return CardLinkTitle.WEBINARS;
      case 'lessons':
        return CardLinkTitle.LESSONS;
      case 'tests':
        return CardLinkTitle.TESTS;
      case 'examination':
        return CardLinkTitle.EXAMINATION;

      default:
        return CardLinkTitle.DEFAULT;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/remotemenu/components/menucard/MenuCard.vue